<!--
 * @Author: your name
 * @Date: 2022-03-08 13:46:19
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-12 20:05:45
 * @Description: file content
活动奖品
活动时间
活动说明
-->
<template>
  <div class="outer1 flex-col">
    <span class="word4">{{ lotteryTitle }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      lotteryTitle: {
        type: String,
        default: "",
      },
    },
  };
</script>

<style lang="less" scoped>
  @height: 50px;
  .flex-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .outer1 {
    height: @height;
    border-radius: 32px;
    box-shadow: 0px 2px -3px 0px rgba(0, 0, 0, 0.148);
    background: url("~@/assets/lottery/orange_bg.png") 0px -6px no-repeat;
    background-size: 100% @height+20px;
    width: 80%;
    padding: 2px 0 0 4px;
    .word4 {
      width: 100%;
      height: @height;
      color: rgba(255, 255, 255, 1);
      font-size: 30px;
      font-family: YouSheBiaoTiHei;
      display: block;
      overflow-wrap: break-word;
      white-space: nowrap;
      line-height: @height;
      text-align: center;
      text-shadow: 0px 2px 4px rgba(247, 88, 0, 1);
    }
  }
</style>
